import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08ee346f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=08ee346f&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ee346f')) {
      api.createRecord('08ee346f', component.options)
    } else {
      api.reload('08ee346f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08ee346f", function () {
      api.rerender('08ee346f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/sector/index.vue"
export default component.exports